import { render, staticRenderFns } from "./AddPPM_monthly.vue?vue&type=template&id=15f2ea60&scoped=true"
import script from "./AddPPM_monthly.vue?vue&type=script&lang=ts"
export * from "./AddPPM_monthly.vue?vue&type=script&lang=ts"
import style0 from "./AddPPM_monthly.vue?vue&type=style&index=0&id=15f2ea60&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f2ea60",
  null
  
)

export default component.exports